'use strict';

const storage = require('./storage-helper');

const handleEvent = event => {
  if (event.id && event.type === 'click') {
    const {
      originalEvent: { target: element },
    } = event;

    if (
      element.dataset &&
      element.dataset.bhc &&
      element.dataset.bhc.includes('direct-link')
    ) {
      if (element.attributes.href) {
        const newHref = `${element.attributes.href.value}?eid=${event.id}`;
        element.setAttribute('href', newHref);
      }
    } else {
      storage.setItem('eventId', event.id);
    }
  }
};

window.onload = function() {
  setTimeout(
    () => window.OptimizeSuite.bloodhound.on('event', handleEvent),
    100
  );
};
